import { initReactI18next } from "react-i18next";
import { Language } from "../../../../../type/Translations.js";
import i18n from "i18next";
import { default as default2 } from "i18next";
import { Remarkable } from "remarkable";
import RemarkableReactRenderer from "remarkable-react";
const md = new Remarkable({
  linkTarget: "_blank"
});
md.renderer = new RemarkableReactRenderer();
const markdownRenderer = (str) => {
  return md.renderInline(str);
};
const markdownModule = {
  type: "postProcessor",
  name: "markdown",
  process(value) {
    return markdownRenderer(value);
  }
};
const markdownBlockModule = {
  type: "postProcessor",
  name: "markdownBlock",
  process(value) {
    return md.render(value);
  }
};
const supportedLanguages = ["en", "de", "cimode"];
const isLanguageValid = (language) => supportedLanguages.includes(language.toLowerCase());
const getLanguageFromNavigator = () => {
  try {
    return window.navigator.language.substring(0, 2) || void 0;
  } catch (e) {
  }
};
const getCurrentLanguage = () => {
  const language = getLanguageFromNavigator();
  if (language && isLanguageValid(language))
    return language.toLowerCase();
  return Language.DEUTSCH;
};
const init = (language) => (resources) => {
  const instance = i18n.use(markdownModule).use(markdownBlockModule).use(initReactI18next).init({
    resources: {
      en: { translation: resources.en },
      de: { translation: resources.de }
    },
    lng: language,
    fallbackLng: Language.ENGLISH,
    interpolation: {
      escapeValue: false
    },
    postProcess: [markdownModule.name]
  });
  return instance;
};
export {
  default2 as default,
  getCurrentLanguage,
  init
};
